import React from 'react'
import Introduction from './components/Introduction'
import Features from './components/Features'
import Footer from './components/Footer'

export default function App() {
return (
  <>

  <Introduction/>
  <Features/>
  <Footer/>

  </>
)
}

